type SecretKey = string;
type EncryptedString = string;

let key = 0;

const generateKey = (secretKey: SecretKey = 'defaultKey'): number =>
  Array.from(secretKey).reduce((key, char) => key + char.charCodeAt(0), 0);

const encrypt = (str: string): EncryptedString => {
  if (!str) return '';

  const encoded = btoa(str);

  return Array.from(encoded)
    .map((char) => String.fromCharCode(char.charCodeAt(0) ^ key))
    .join('');
};

const decrypt = (encryptedStr: EncryptedString): string => {
  if (!encryptedStr) return '';

  try {
    const decoded = Array.from(encryptedStr)
      .map((char) => String.fromCharCode(char.charCodeAt(0) ^ key))
      .join('');

    return atob(decoded);
  } catch (e) {
    console.error(
      'Decryption failed:',
      e instanceof Error ? e.message : String(e),
    );
    return '';
  }
};

export function useCypher(secretKey = 'defaultKey') {
  key = generateKey(secretKey);

  return {
    encrypt,
    decrypt,
  };
}
